"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNumeric = isNumeric;
const isArray = (function () {
    return (Array.isArray ||
        function (x) {
            return x && typeof x.length === "number";
        });
})();
/**
 * **exported from "rxjs/internal-compatibility" v6**
 * @deprecated
 */
function isNumeric(val) {
    return !isArray(val) && val - parseFloat(val) + 1 >= 0;
}
//# sourceMappingURL=isNumeric.js.map